import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import LoginDialog from '../app/LoginDialog';
import LoginManager from '../app/LoginManager';

class DetailPageLoginObserver implements Observer {
    readonly #loginManager = LoginManager.getInstance();

    readonly #contactAnchor: HTMLAnchorElement | null = document.querySelector<HTMLAnchorElement>(
        '[data-role="contact-with-landlord"]'
    );

    public constructor() {
        this.#loginManager.attach(this);

        if (this.#loginManager.isLoggedIn) {
            return;
        }

        this.#setEventListeners();
    }

    public static init(): DetailPageLoginObserver {
        return new DetailPageLoginObserver();
    }

    public async update(): Promise<void> {
        if (!this.#loginManager.isLoggedIn) {
            return;
        }

        this.#removeEventListeners();
    }

    #setEventListeners(): void {
        this.#contactAnchor?.addEventListener('click', this.#handleClickEvent);
    }

    #removeEventListeners(): void {
        this.#contactAnchor?.removeEventListener('click', this.#handleClickEvent);
    }

    readonly #handleClickEvent = async (event: Event): Promise<void> => {
        event.preventDefault();
        const loginDialog = LoginDialog.getInstance('contact-login-dialog');
        await loginDialog.show();
    };
}

export default DetailPageLoginObserver;
